import { EyeIcon, EyeSlashIcon } from '@phosphor-icons/react';
import * as React from 'react';
import colors from 'tailwindcss/colors';

import { cn } from '@/lib/utils';

import { Input } from './input';

const PasswordInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'>
>(({ className, ...props }, ref) => {
  const [inputType, setInputType] = React.useState('password');

  const changeVisibility = () => {
    setInputType((prev) => (prev === 'password' ? 'text' : 'password'));
  };

  const iconColor = String(props.value).trim().length
    ? colors.zinc[200]
    : colors.zinc[400];

  const icon =
    inputType === 'password' ? (
      <EyeSlashIcon
        data-testid="show-password-icon"
        color={iconColor}
        size={28}
      />
    ) : (
      <EyeIcon data-testid="hide-password-icon" color={iconColor} size={28} />
    );

  return (
    <div className="relative">
      <Input
        type={inputType}
        ref={ref}
        placeholder="Enter the password"
        autoComplete="new-password"
        className={cn('pr-12', className)}
        {...props}
      />

      <div
        className="opacity-80 absolute inset-y-0 right-0 w-12 flex justify-center items-center cursor-pointer"
        onClick={changeVisibility}
      >
        {icon}
      </div>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
